export const defaultFournitures = [
  // COLLÈGE (6 listes)
  {
    id: 1,
    titre: "Liste des Fournitures & Manuels - Classe de 6ème",
    classe: "6ème",
    cycle: "college",
    annee_scolaire: "2026-2027",
    description: "Liste officielle certifiée des fournitures, cahiers et manuels scolaires agréés pour la classe de 6ème.",
    articles: [
      "4 Cahiers 200 pages grand format (21x29.7) lignés",
      "3 Cahiers 100 pages petit format",
      "1 Manuel de Mathématiques CIAM 6ème",
      "1 Manuel d'Anglais 'English for French Speakers 6e'",
      "1 Manuel de Français 'Grammaire & Expression 6e'",
      "1 Boîte d'instruments de géométrie (Règle 30cm, Équerre, Rapporteur, Compas)",
      "1 Trousse garnie (Stylos bleu, rouge, vert, noir, Crayon HB, Gomme, Taille-crayon)",
      "1 Cahier de dessin & Boîte de crayons de couleur (12 couleurs)",
      "1 Uniforme officiel GSU (Tenue de classe & Tenue d'Égalité Sportive)"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_001d348d9fc345b4274d9e94061112e8.pdf",
    publie: true,
    telechargements: 284
  },
  {
    id: 2,
    titre: "Liste des Fournitures & Manuels - Classe de 5ème",
    classe: "5ème",
    cycle: "college",
    annee_scolaire: "2026-2027",
    description: "Liste officielle certifiée des fournitures, cahiers et manuels scolaires agréés pour la classe de 5ème.",
    articles: [
      "5 Cahiers 200 pages grand format (21x29.7)",
      "3 Cahiers 100 pages petit format",
      "1 Manuel CIAM Mathématiques 5ème",
      "1 Manuel d'Histoire-Géographie 5ème",
      "1 Manuel de SVT & Physique-Chimie 5ème",
      "1 Calculatrice scientifique de collège (CASIO ou similaire)",
      "1 Ensemble de géométrie complet & Crayon de couleur",
      "1 Uniforme officiel GSU Les Palmiers"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_05a7d194e5cbca957ea84cfc1c5540c3.pdf",
    publie: true,
    telechargements: 219
  },
  {
    id: 3,
    titre: "Liste des Fournitures & Manuels - Classe de 4ème",
    classe: "4ème",
    cycle: "college",
    annee_scolaire: "2026-2027",
    description: "Liste officielle certifiée des fournitures, cahiers et manuels scolaires agréés pour la classe de 4ème.",
    articles: [
      "6 Cahiers 200 pages grand format (21x29.7)",
      "4 Cahiers 100 pages petit format",
      "1 Manuel de Mathématiques CIAM 4ème",
      "1 Manuel de Physique-Chimie 4ème",
      "1 Manuel de SVT 4ème",
      "1 Dictionnaire Le Robert ou Larousse Français / Anglais",
      "1 Calculatrice scientifique avancée",
      "1 Blouse blanche 100% coton pour Travaux Pratiques"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_0e9af3888185364f6343ecde3ae707b3.pdf",
    publie: true,
    telechargements: 195
  },
  {
    id: 4,
    titre: "Liste des Fournitures & Manuels - Classe de 3ème (Prépa BEPC)",
    classe: "3ème",
    cycle: "college",
    annee_scolaire: "2026-2027",
    description: "Liste officielle certifiée des fournitures, annales et manuels scolaires pour la préparation au BEPC.",
    articles: [
      "8 Cahiers 200 pages grand format (21x29.7)",
      "1 Annales BEPC Mathématiques, Physique-Chimie & SVT",
      "1 Annales BEPC Français, Histoire-Géo & Anglais",
      "1 Manuel CIAM Mathématiques 3ème",
      "1 Calculatrice scientifique certifiée épreuves BEPC",
      "1 Boîte d'instruments de traçage géométrique",
      "1 Blouse blanche en coton pour Travaux Pratiques",
      "1 Rame de papier A4 80g pour devoirs de synthèse"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_0fbec92c0c239e1830e1222f74f05c7f.pdf",
    publie: true,
    telechargements: 342
  },
  {
    id: 5,
    titre: "Fournitures Spécifiques - Classe de 6ème Bilingue / Renforcée",
    classe: "6ème Bilingue",
    cycle: "college",
    annee_scolaire: "2026-2027",
    description: "Programme d'immersion bilingue : manuels d'anglais renforcé et fournitures spécifiques.",
    articles: [
      "1 Oxford English Dictionary & Grammar Guide",
      "5 Cahiers 200 pages grand format",
      "1 Manuel CIAM Mathématiques (Édition Bilingue)",
      "1 Workbook Listening & Speaking avec support audio",
      "1 Trousse complète et fournitures standards 6ème"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_0fc272b1240d7f1f7aafd2198d8fd4ef.pdf",
    publie: true,
    telechargements: 140
  },
  {
    id: 6,
    titre: "Fournitures & Équipements - 3ème Pré-Technique / Initiation Métiers",
    classe: "3ème Pré-Tech",
    cycle: "college",
    annee_scolaire: "2026-2027",
    description: "Initiation aux technologies et métiers techniques du CPET : outillage de base et cahiers.",
    articles: [
      "4 Cahiers de travaux pratiques grands carreaux",
      "1 Kit outillage de base (Tournevis isolé, Pince universelle, Mètre ruban)",
      "1 Planche de dessin technique format A3 & Équerres 45°/60°",
      "1 Paire de chaussures de sécurité légères & Blouse d'atelier",
      "1 Annales BEPC Technique & Manuel de technologie"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_3bbb7e6278e2b06620d050cd69722184.pdf",
    publie: true,
    telechargements: 178
  },

  // SECONDES (7 listes)
  {
    id: 7,
    titre: "Liste des Fournitures & Manuels - Seconde A (Littéraire)",
    classe: "Seconde A",
    cycle: "seconde",
    annee_scolaire: "2026-2027",
    description: "Ouvrages littéraires, œuvres au programme, philosophie et fournitures pour la Seconde A.",
    articles: [
      "6 Cahiers 200 pages grand format (21x29.7)",
      "3 Œuvres littéraires au programme officiel de Français 2nde A",
      "1 Dictionnaire de Philosophie & Citations littéraires",
      "1 Manuel de Français & Littérature Seconde A",
      "2 Cahiers de langues vivantes (Anglais, Allemand / Espagnol)"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_45bb0502059099bd346eab47ec62c4ce.pdf",
    publie: true,
    telechargements: 215
  },
  {
    id: 8,
    titre: "Liste des Fournitures & Manuels - Seconde C (Scientifique)",
    classe: "Seconde C",
    cycle: "seconde",
    annee_scolaire: "2026-2027",
    description: "Mathématiques avancées, Physique-Chimie, calculatrices scientifiques agréées et fournitures 2nde C.",
    articles: [
      "8 Cahiers 200 pages grand format (21x29.7)",
      "1 Manuel CIAM Mathématiques Seconde C",
      "1 Manuel de Physique-Chimie Seconde C (Édition IPAM)",
      "1 Calculatrice scientifique graphique / programmable agréée",
      "1 Blouse blanche 100% coton à manches longues pour TP",
      "1 Matériel de dessin technique & Carnet de papier millimétré"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_4690dca790fbbb9e1ab2f535649d2fa0.pdf",
    publie: true,
    telechargements: 290
  },
  {
    id: 9,
    titre: "Liste des Fournitures - Seconde G2 (Gestion & Comptabilité)",
    classe: "Seconde G2",
    cycle: "seconde",
    annee_scolaire: "2026-2027",
    description: "Plan comptable général SYSCOHADA, classeurs de gestion, documents fiscaux et manuels G2.",
    articles: [
      "1 Plan Comptable Général SYSCOHADA Révisé (Dernière édition)",
      "6 Cahiers 200 pages grand format (21x29.7)",
      "1 Manuel de Comptabilité Financière 2nde G2",
      "1 Calculatrice financière ou scientifique 12 chiffres",
      "1 Classeur à leviers 4 anneaux & Pochettes plastifiées perforées",
      "1 Manuel d'Organisation et Gestion des Entreprises"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_61c8dcdb0ed1dc7bad41acd7abb2358f.pdf",
    publie: true,
    telechargements: 260
  },
  {
    id: 10,
    titre: "Fournitures & Outillage - Seconde F3 (Électrotechnique)",
    classe: "Seconde F3",
    cycle: "seconde",
    annee_scolaire: "2026-2027",
    description: "Équipements de protection individuelle (EPI), multimètre, outillage d'atelier et manuels F3.",
    articles: [
      "1 Multimètre numérique de mesure électrique (CAT III)",
      "1 Boîte d'outillage d'atelier (Pince à dénuder, Pince coupante, Tournevis 1000V)",
      "2 Cahiers de schéma électrique grand format",
      "1 Blouse d'atelier & Lunettes de protection homologuées",
      "1 Manuel de Technologie Électrotechnique F3"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_6d085992187e0414aca7f3e66bb13a53.pdf",
    publie: true,
    telechargements: 228
  },
  {
    id: 11,
    titre: "Fournitures & Matériel de Dessin - Seconde F4 (Génie Civil / BTP)",
    classe: "Seconde F4",
    cycle: "seconde",
    annee_scolaire: "2026-2027",
    description: "Planche à dessin, té, équerres professionnelles, casque de chantier et fournitures F4.",
    articles: [
      "1 Planche à dessin technique portable (Format A2 ou A3) avec règle parallèle",
      "1 Équerre 45°, Équerre 60° (30cm) & Kutch (Règle à échelle)",
      "1 Casque de chantier homologué & Chaussures de sécurité BTP",
      "6 Cahiers de cours grand format (21x29.7)",
      "1 Manuel de Mécanique Appliquée & Dessin de bâtiment"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_749050c444b397dc6f2ac465e94d12dd.pdf",
    publie: true,
    telechargements: 185
  },
  {
    id: 12,
    titre: "Fournitures & Tenues Professionnelles - Seconde HR (Hôtellerie-Restauration)",
    classe: "Seconde HR",
    cycle: "seconde",
    annee_scolaire: "2026-2027",
    description: "Mallette de couteaux professionnelle, tabliers, uniforme de service et manuels de technologie culinaire.",
    articles: [
      "1 Mallette professionnelle de couteaux de cuisine (Découper, Émincer, d'Office)",
      "1 Tenue complète de cuisine (Veste blanche, Pantalon, Coiffe/Toque, Tablier)",
      "1 Uniforme de service en salle (Chemise blanche, Pantalon/Jupe noir, Cravate/Noeud papillon)",
      "4 Cahiers de technologie culinaire & Hygiène alimentaire"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_7cf60f4a9d555e322893f9f70247c144.pdf",
    publie: true,
    telechargements: 164
  },
  {
    id: 13,
    titre: "Fournitures & Trousse de Stylisme - Seconde MM-V (Métiers de la Mode)",
    classe: "Seconde MM-V",
    cycle: "seconde",
    annee_scolaire: "2026-2027",
    description: "Ciseaux de coupe tailleur, perroquets de patronage, roulette, tissus d'étude et cahiers de croquis.",
    articles: [
      "1 Ciseaux de coupe professionnels pour tissu (Acier forgé 25cm)",
      "1 Ensemble Pistolets / Perroquets de patronage & Règle japonaise transparente",
      "1 Mètre ruban de couturière & Mètre rigide",
      "1 Boîte d'épingles à tête de verre & Craies de tailleur",
      "5 mètres de Toile de coton blanc d'étude & Cahier de croquis de mode"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_87ab6dcb91f2d443afe729ae1fb03508.pdf",
    publie: true,
    telechargements: 310
  },

  // PREMIÈRES (8 listes)
  {
    id: 14,
    titre: "Liste des Fournitures & Manuels - Première A (Littéraire)",
    classe: "Première A",
    cycle: "premiere",
    annee_scolaire: "2026-2027",
    description: "Anthologies littéraires, œuvres théâtrales et poétiques, langues vivantes et fournitures 1ère A.",
    articles: [
      "1 Anthologie de la Littérature Africaine & Francophone (1ère A)",
      "4 Œuvres intégrales au programme du Baccalauréat Première",
      "6 Cahiers 200 pages grand format (21x29.7)",
      "1 Manuel de Philosophie de Première",
      "1 Dictionnaire bilingue Anglais/Français approfondi"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_8e78568100ea48f83f1b3be781757aa0.pdf",
    publie: true,
    telechargements: 175
  },
  {
    id: 15,
    titre: "Liste des Fournitures & Manuels - Première B (Économique)",
    classe: "Première B",
    cycle: "premiere",
    annee_scolaire: "2026-2027",
    description: "Sciences économiques et sociales, mathématiques appliquées, statistiques et manuels 1ère B.",
    articles: [
      "1 Manuel de Sciences Économiques et Sociales 1ère B",
      "6 Cahiers 200 pages grand format (21x29.7)",
      "1 Calculatrice scientifique avec fonctions statistiques",
      "1 Fascicule d'Économie Générale & Histoire des faits économiques"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_905263bfd9444462c0d4bdc93f1c204a.pdf",
    publie: true,
    telechargements: 160
  },
  {
    id: 16,
    titre: "Liste des Fournitures & Manuels - Première C (Maths-Physique)",
    classe: "Première C",
    cycle: "premiere",
    annee_scolaire: "2026-2027",
    description: "Collection CIAM 1ère C, annales d'exercices de physique-chimie et fournitures scientifiques.",
    articles: [
      "1 Collection CIAM Mathématiques Première C",
      "1 Manuel de Physique-Chimie Première C",
      "1 Calculatrice scientifique programmable avancée",
      "1 Recueil d'Annales d'exercices corrigés Première C",
      "1 Blouse blanche 100% coton pour Travaux Pratiques"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_97ed48043a03e3925b26fc911f2b0cf5.pdf",
    publie: true,
    telechargements: 230
  },
  {
    id: 17,
    titre: "Liste des Fournitures & Manuels - Première D (Sciences Biologiques)",
    classe: "Première D",
    cycle: "premiere",
    annee_scolaire: "2026-2027",
    description: "SVT, anatomie humaine, biochimie, fascicules de travaux pratiques et manuels 1ère D.",
    articles: [
      "1 Manuel de SVT Première D (Anatomie, Physiologie, Génétique)",
      "1 Manuel de Chimie Organique & Minérale 1ère D",
      "1 Trousse de dissection complète (Bistouri, Pince fine, Ciseaux, Aiguilles)",
      "1 Blouse de TP blanche & Carnet de papier millimétré",
      "6 Cahiers 200 pages grand format (21x29.7)"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_9c5e7767aef3c724d0aa2f48afeeec5e.pdf",
    publie: true,
    telechargements: 280
  },
  {
    id: 18,
    titre: "Liste des Fournitures - Première G2 (Comptabilité Approfondie)",
    classe: "Première G2",
    cycle: "premiere",
    annee_scolaire: "2026-2027",
    description: "Comptabilité financière, droit commercial OHADA, logiciels de gestion et fournitures 1ère G2.",
    articles: [
      "1 Plan Comptable SYSCOHADA Révisé",
      "1 Manuel de Comptabilité Approfondie & Droit Commercial OHADA",
      "6 Cahiers 200 pages grand format (21x29.7)",
      "1 Calculatrice scientifique ou financière",
      "1 Recueil d'études de cas comptables & fiscaux"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_9ca3b7a2e023ad4c28095cded59ede8d.pdf",
    publie: true,
    telechargements: 245
  },
  {
    id: 19,
    titre: "Fournitures & Ateliers - Première F3 (Électrotechnique)",
    classe: "Première F3",
    cycle: "premiere",
    annee_scolaire: "2026-2027",
    description: "Schémas électriques, automatique industrielle, composants de laboratoire et outillage F3.",
    articles: [
      "1 Multimètre numérique & Fer à souder 30W avec fil d'étain",
      "1 Schématèque d'Automatisme & Schémas Électriques",
      "1 Outillage individuel complet d'électricien (1000V)",
      "1 Paire de chaussures de sécurité & Blouse d'atelier F3"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_a69a0acb89e3e00805d10037076970cb.pdf",
    publie: true,
    telechargements: 210
  },
  {
    id: 20,
    titre: "Fournitures & Métrologie - Première F4 (Bâtiment & Travaux Publics)",
    classe: "Première F4",
    cycle: "premiere",
    annee_scolaire: "2026-2027",
    description: "Topographie, résistance des matériaux (RDM), dessin technique assisté et fournitures F4.",
    articles: [
      "1 Règle à calcul Kutch & Matériel de dessin d'architecture",
      "1 Manuel de Topographie & Mécanique des structures (RDM)",
      "1 Casque de chantier, Chaussures de sécurité & Gilet haute visibilité",
      "6 Cahiers de cours grand format (21x29.7)"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_b555154dfa74d78b4bcab3e615e2b28b.pdf",
    publie: true,
    telechargements: 198
  },
  {
    id: 21,
    titre: "Fournitures de Création & Stylisme - Première MM-V (Mode & Vêtements)",
    classe: "Première MM-V",
    cycle: "premiere",
    annee_scolaire: "2026-2027",
    description: "Matériel professionnel de patronage industriel, mannequin d'étude, mercerie et étoffes.",
    articles: [
      "1 Mannequin de couture d'étude (Taille standard 38)",
      "1 Paire de ciseaux de coupe tailleur & Ciseaux cranteurs",
      "20 mètres de Papier kraft & Papier de soie pour patronage",
      "1 Kit de mercerie complète (Fermetures éclair, Fils assortis, Boutons)"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_bcd66a168909e0ae2bbb758518d0799e.pdf",
    publie: true,
    telechargements: 295
  },

  // TERMINALES (7 listes)
  {
    id: 22,
    titre: "Liste des Fournitures - Terminale A (Baccalauréat Littéraire)",
    classe: "Terminale A",
    cycle: "terminale",
    annee_scolaire: "2026-2027",
    description: "Philosophie, littérature africaine et mondiale, annales officielles du BAC et fournitures Tle A.",
    articles: [
      "1 Annales officielles du BAC A (Philosophie, Français, Histoire-Géo, Anglais)",
      "4 Œuvres au programme du Baccalauréat 2026-2027",
      "6 Cahiers 200 pages grand format (21x29.7)",
      "1 Manuel d'Histoire-Géographie Terminale A",
      "1 Répertoire de citations philosophiques et littéraires"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_bfa46550aace4566f19c8eba21f4bb50.pdf",
    publie: true,
    telechargements: 390
  },
  {
    id: 23,
    titre: "Liste des Fournitures - Terminale B (Baccalauréat Économique)",
    classe: "Terminale B",
    cycle: "terminale",
    annee_scolaire: "2026-2027",
    description: "Économie approfondie, sociologie, annales du Baccalauréat et fournitures complètes Tle B.",
    articles: [
      "1 Annales officielles du BAC B (SES, Mathématiques, Économie)",
      "1 Manuel de Sociologie & Économie Contemporaine Terminale B",
      "1 Calculatrice graphique programmable",
      "6 Cahiers 200 pages grand format (21x29.7)"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_c7e3e0ab4292d19dedcb4b565c999a57.pdf",
    publie: true,
    telechargements: 210
  },
  {
    id: 24,
    titre: "Liste des Fournitures - Terminale C (Baccalauréat Scientifique C)",
    classe: "Terminale C",
    cycle: "terminale",
    annee_scolaire: "2026-2027",
    description: "Collection CIAM Terminale SM, annales de mathématiques et physique, calculatrices programmables.",
    articles: [
      "1 Collection CIAM Mathématiques Terminale SM/C",
      "1 Manuel de Physique-Chimie Terminale C (Édition Supérieure)",
      "1 Annales du BAC C Mathématiques & Physique (10 dernières années)",
      "1 Calculatrice scientifique graphique certifiée examen BAC",
      "1 Blouse de TP & Cahier d'expérimentation"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_c9eddb88c7e39c124762ba4883801039.pdf",
    publie: true,
    telechargements: 360
  },
  {
    id: 25,
    titre: "Liste des Fournitures - Terminale D (Baccalauréat Scientifique D)",
    classe: "Terminale D",
    cycle: "terminale",
    annee_scolaire: "2026-2027",
    description: "SVT approfondie, génétique, annales du BAC D, fiches de synthèse et fournitures Tle D.",
    articles: [
      "1 Annales BAC D (SVT, Physique-Chimie, Mathématiques)",
      "1 Manuel de SVT Terminale D (Génétique humaine, Immunologie, Évolution)",
      "1 Kit complet de Travaux Pratiques SVT",
      "1 Blouse blanche de TP à manches longues",
      "8 Cahiers 200 pages grand format (21x29.7)"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_cba8a391d20c2420e7830612310d8863.pdf",
    publie: true,
    telechargements: 450
  },
  {
    id: 26,
    titre: "Liste des Fournitures - Terminale G2 (Baccalauréat Technique Comptabilité-Gestion)",
    classe: "Terminale G2",
    cycle: "terminale",
    annee_scolaire: "2026-2027",
    description: "Filière championne nationale 2024 : comptabilité des sociétés, fiscalité, mathématiques financières et annales BAC G2.",
    articles: [
      "1 Plan Comptable SYSCOHADA Révisé (Obligatoire pour les épreuves du BAC)",
      "1 Annales du BAC G2 (Comptabilité, Gestion, Fiscalité, Droit OHADA)",
      "1 Calculatrice scientifique ou financière certifiée",
      "1 Manuel de Fiscalité des Entreprises & Mathématiques Financières",
      "6 Cahiers 200 pages grand format (21x29.7)"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_cca7ade69488a18601f8cdc3cfc20176.pdf",
    publie: true,
    telechargements: 520
  },
  {
    id: 27,
    titre: "Liste des Fournitures - Terminale F3 (Baccalauréat Électrotechnique)",
    classe: "Terminale F3",
    cycle: "terminale",
    annee_scolaire: "2026-2027",
    description: "Machines électriques, distribution d'énergie, électronique de puissance et manuels d'examen BAC F3.",
    articles: [
      "1 Annales du BAC F3 Électrotechnique & Schémas Électriques",
      "1 Outillage professionnel complet (Multimètre, Pince à sertir, Dénudeur)",
      "1 Équipements de Protection Individuelle (EPI) pour épreuves pratiques BAC F3",
      "1 Manuel de Machines Électriques & Automatisme Industriel"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_d4db60cdb2e385f9593ce333cb99ecee.pdf",
    publie: true,
    telechargements: 310
  },
  {
    id: 28,
    titre: "Liste des Fournitures - Terminale F4 (Baccalauréat Génie Civil / BTP)",
    classe: "Terminale F4",
    cycle: "terminale",
    annee_scolaire: "2026-2027",
    description: "Calcul de structures, métré et devis, dessin d'architecture, équipement de sécurité et annales BAC F4.",
    articles: [
      "1 Annales du BAC F4 (Calcul de structures, Dessin BTP, Métré)",
      "1 Matériel de Dessin de Bâtiment (Kutch, Équerres, Planche A2/A3)",
      "1 Équipements complets de chantier BTP (Casque, Chaussures, Gilet)",
      "1 Manuel de Métré & Étude des prix"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_e278e9c0d4cc30febc84edc9e3bf4203.pdf",
    publie: true,
    telechargements: 275
  },

  // SUPÉRIEUR & FORMATION PROFESSIONNELLE (1 liste regroupée)
  {
    id: 29,
    titre: "Fournitures & Outils Numériques - BTS / Licence DWM & Formations Qualifiantes CPFPA",
    classe: "DWM / Supérieur",
    cycle: "superieur",
    annee_scolaire: "2026-2027",
    description: "Développement Web & Multimédia, Maintenance IMI, Électronique : suite logicielle recommandée, ordinateurs portables et supports.",
    articles: [
      "1 Ordinateur portable recommandé (Intel i5/i7 ou AMD Ryzen 5/7, 16Go RAM, SSD 512Go)",
      "1 Suite logicielle de développement Web & Design (VS Code, Git, Figma, Docker)",
      "1 Support de stockage externe (Clé USB 64Go ou Disque dur externe 1To)",
      "4 Cahiers de notes & Blouse de laboratoire informatique"
    ],
    fichier_pdf: "/documents/fournitures/fourniture_e6ab352998b402f52f556ee2e7ef40d1.pdf",
    publie: true,
    telechargements: 380
  }
];
